import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../../../../../environments/environment';
import {OAuthSystem} from '../../../../../../../_api/IdentityClient';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../../../../../_services/authentication.service';
import {MatDialog} from '@angular/material/dialog';
import {PopupSocialAuthBase} from '../PopupSocialAuthBase';

@Component({
  selector: 'app-apple-auth',
  templateUrl: './apple-auth.component.pug',
  styleUrls: ['./apple-auth.component.sass']
})
export class AppleAuthComponent extends PopupSocialAuthBase {
  constructor(authenticationService: AuthenticationService,
              router: Router,
              route: ActivatedRoute,
              dialog: MatDialog) {
    super(authenticationService, router, route, dialog);
  }

  @Input() isAuthPage: boolean = false;

  protected getPopupUri(): string {
    return `${environment.api.identity}/api/authorization/apple`;
  }

  protected getOAuthRequestSystem(): OAuthSystem {
    return OAuthSystem.AppleId;
  }
}
